import React from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';

import InputMask from 'react-input-mask';
import Joyride from 'react-joyride';
import {
  Form,
  Input,
  Button,
  Card,
  Row,
  Col,
  Modal,
  Typography,
  Divider,
  Alert,
  Result
} from 'antd';
import {
  SaveOutlined,
  CheckCircleOutlined,
  InfoCircleOutlined,
  InstagramOutlined
} from '@ant-design/icons';

import { editarContrato, salvarEndereco, obterContratoPeloUsuario } from '../actions/ContratoActions';
import { cadastrarAcao } from '../actions/AcaoActions';
import EmailService from '../services/EmailService';

const { Title, Text } = Typography;

class InformacoesEntrega extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      itens: [],
      formandos: [],
      itensFormando: [],
      endereco: {
        nome: "",
        cpf: "",
        rg: "",
        celular: "",
        email: "",
        rua: "",
        complemento: "",
        numero: "",
        bairro: "",
        cidade: "",
        estado: "",
        cep: "",
        contrato: ""
      },
      classInputs: {
        nome: "",
        cpf: "",
        rg: "",
        celular: "",
        email: "",
        rua: "",
        bairro: "",
        numero: "",
        cidade: "",
        estado: "",
        cep: ""
      },
      showModalNotificacao: false,
      botaoFinalizar: false,
      run: false,
      steps: [
        {
          content: <div><h3>Bem-vindo(a)!</h3><p>Esta é a página de cadastro das informações de faturamento e entrega.</p></div>,
          placement: 'center',
          target: '#divContent'
        },
        {
          content: <div><h3>Formulário de Dados</h3><p>Preencha corretamente todos estes campos para garantir o faturamento e entrega corretos dos seus convites.</p></div>,
          placement: 'bottom',
          target: '#cardForm'
        },
        {
          content: <div><h3>Finalizar</h3><p>Após preencher tudo, clique neste botão para salvar e finalizar a etapa.</p></div>,
          target: '#btnFinalizarEtapa'
        }
      ]
    }
  }

  async componentDidMount() {
    if (this.props.usuario.tipo === "comissao") {
      await this.props.obterContratoPeloUsuario(this.props.usuario.id);
      if (this.props.contrato.endereco === undefined) {
        this.setState({ run: true });
      } else {
        this.setState({ endereco: this.props.contrato.endereco, finalizado: true });
      }
    }
  }

  limparClassInputs() {
    let inputs = Object.keys(this.state.classInputs),
      classInputs = this.state.classInputs;
    inputs.forEach((input) => {
      classInputs[input] = "";
    });
    this.setState({ classInputs });
  }

  verificarInputs() {
    let classInputs = this.state.classInputs,
      inputs = Object.keys(classInputs),
      existemCamposNaoPreenchidos = false;
    inputs.forEach((input) => {
      if (this.state.endereco[input] === null || this.state.endereco[input] === undefined || this.state.endereco[input] === "") {
        classInputs[input] = "error";
        existemCamposNaoPreenchidos = true;
      }
    });
    this.setState({ classInputs });
    return existemCamposNaoPreenchidos;
  }

  async salvarInformacoesEntrega() {
    let { endereco } = this.state,
      email = new EmailService();
    endereco.contrato = this.props.contrato.id;
    await this.setState({ botaoFinalizar: true });

    if (!this.verificarInputs()) {
      await this.props.salvarEndereco(endereco, this.props.contrato.id)
        .then(async () => {
          // Recarregar o contrato atualizado
          await this.props.obterContratoPeloUsuario(this.props.contrato.usuario.id);

          //notificacao ao admim que foi realizado distribuição de itens
          let acao = {
            ator: this.props.contrato.dono.id,
            texto: "A comissão do contrato " + this.props.contrato.numero + " preencheu as informações de entrega",
            data: new Date(),
            contrato: this.props.contrato.id,
            tipo: "comissao",
            visualizado: false
          }
          email.enviar("updateAcaoComissaoToDesigner", {
            numero: this.props.contrato.numero,
            mensagem: "o cadastro das informações de faturamento/entrega",
            designer: { email: this.props.contrato.dono.email }
          });
          this.props.cadastrarAcao(acao);
        })
        .finally(() => {
          this.setState({ botaoFinalizar: false, showModalNotificacao: true });
        })
    } else {
      this.setState({ botaoFinalizar: false });
    }
  }

  alterarForm(event) {
    const campo = event.target.name;
    const endereco = this.state.endereco;
    endereco[campo] = event.target.value;
    this.limparClassInputs();
    return this.setState({ endereco });
  }

  render() {
    if (this.props.usuario.tipo === "formando") {
      return <Redirect to="/" />;
    }

    const { endereco, classInputs } = this.state;
    const { contrato } = this.props;
    const isReadOnly = contrato.enderecoPreenchido;

    return (
      <div id="divContent" style={{ padding: '20px', maxWidth: '1200px', margin: '0 auto' }}>
        <Card
          bordered={false}
          style={{ boxShadow: '0 4px 12px rgba(0,0,0,0.08)', borderRadius: '8px' }}
        >
          <div style={{ marginBottom: 24 }}>
            <Title level={2}>Informações de Entrega</Title>
            <Text type="secondary">Preencha os dados abaixo para o faturamento e entrega dos convites.</Text>
          </div>

          {contrato.enderecoPreenchido ? (
            <Alert
              message="Etapa Concluída"
              description="As informações já foram enviadas com sucesso."
              type="success"
              showIcon
              icon={<CheckCircleOutlined />}
              style={{ marginBottom: 24, borderRadius: '8px' }}
            />
          ) : (
            <Alert
              message="Importante"
              description="Os convites serão entregues no endereço abaixo. Certifique-se de que todas as informações estão corretas."
              type="info"
              showIcon
              icon={<InfoCircleOutlined />}
              style={{ marginBottom: 24, borderRadius: '8px' }}
            />
          )}

          <div id="cardForm">
            <Form layout="vertical">
              <Divider orientation="left">Dados do Proprietário</Divider>
              <Row gutter={16}>
                <Col xs={24} md={24}>
                  <Form.Item
                    label="Nome Completo"
                    validateStatus={classInputs.nome}
                    help={classInputs.nome === 'error' ? 'Campo obrigatório' : ''}
                  >
                    <Input
                      name="nome"
                      value={endereco.nome}
                      onChange={this.alterarForm.bind(this)}
                      disabled={isReadOnly}
                      size="large"
                      placeholder="Nome completo do responsável"
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} md={16}>
                  <Form.Item
                    label="E-mail"
                    validateStatus={classInputs.email}
                    help={classInputs.email === 'error' ? 'Campo obrigatório' : ''}
                  >
                    <Input
                      name="email"
                      type="email"
                      value={endereco.email}
                      onChange={this.alterarForm.bind(this)}
                      disabled={isReadOnly}
                      size="large"
                      placeholder="email@exemplo.com"
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} md={8}>
                  <Form.Item
                    label="Celular"
                    validateStatus={classInputs.celular}
                    help={classInputs.celular === 'error' ? 'Campo obrigatório' : ''}
                  >
                    <InputMask
                      mask="(99) 9 9999-9999"
                      value={endereco.celular}
                      onChange={this.alterarForm.bind(this)}
                      disabled={isReadOnly}
                      className="ant-input ant-input-lg"
                      name="celular"
                      placeholder="(99) 9 9999-9999"
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12}>
                  <Form.Item
                    label="CPF"
                    validateStatus={classInputs.cpf}
                    help={classInputs.cpf === 'error' ? 'Campo obrigatório' : ''}
                  >
                    <InputMask
                      mask="999.999.999-99"
                      value={endereco.cpf}
                      onChange={this.alterarForm.bind(this)}
                      disabled={isReadOnly}
                      className="ant-input ant-input-lg"
                      name="cpf"
                      placeholder="999.999.999-99"
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12}>
                  <Form.Item
                    label="RG"
                    validateStatus={classInputs.rg}
                    help={classInputs.rg === 'error' ? 'Campo obrigatório' : ''}
                  >
                    <Input
                      name="rg"
                      value={endereco.rg}
                      onChange={this.alterarForm.bind(this)}
                      disabled={isReadOnly}
                      size="large"
                    />
                  </Form.Item>
                </Col>
              </Row>

              <Divider orientation="left">Endereço de Entrega</Divider>
              <Row gutter={16}>
                <Col xs={24} md={20}>
                  <Form.Item
                    label="Rua / Logradouro"
                    validateStatus={classInputs.rua}
                    help={classInputs.rua === 'error' ? 'Campo obrigatório' : ''}
                  >
                    <Input
                      name="rua"
                      value={endereco.rua}
                      onChange={this.alterarForm.bind(this)}
                      disabled={isReadOnly}
                      size="large"
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} md={4}>
                  <Form.Item
                    label="Número"
                    validateStatus={classInputs.numero}
                    help={classInputs.numero === 'error' ? 'Campo obrigatório' : ''}
                  >
                    <Input
                      type="number"
                      name="numero"
                      value={endereco.numero}
                      onChange={this.alterarForm.bind(this)}
                      disabled={isReadOnly}
                      size="large"
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12}>
                  <Form.Item
                    label="Bairro"
                    validateStatus={classInputs.bairro}
                    help={classInputs.bairro === 'error' ? 'Campo obrigatório' : ''}
                  >
                    <Input
                      name="bairro"
                      value={endereco.bairro}
                      onChange={this.alterarForm.bind(this)}
                      disabled={isReadOnly}
                      size="large"
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12}>
                  <Form.Item label="Complemento">
                    <Input
                      name="complemento"
                      value={endereco.complemento}
                      onChange={this.alterarForm.bind(this)}
                      disabled={isReadOnly}
                      size="large"
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} md={8}>
                  <Form.Item
                    label="CEP"
                    validateStatus={classInputs.cep}
                    help={classInputs.cep === 'error' ? 'Campo obrigatório' : ''}
                  >
                    <InputMask
                      mask="99999-999"
                      value={endereco.cep}
                      onChange={this.alterarForm.bind(this)}
                      disabled={isReadOnly}
                      className="ant-input ant-input-lg"
                      name="cep"
                      placeholder="99999-999"
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12}>
                  <Form.Item
                    label="Cidade"
                    validateStatus={classInputs.cidade}
                    help={classInputs.cidade === 'error' ? 'Campo obrigatório' : ''}
                  >
                    <Input
                      name="cidade"
                      value={endereco.cidade}
                      onChange={this.alterarForm.bind(this)}
                      disabled={isReadOnly}
                      size="large"
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} md={4}>
                  <Form.Item
                    label="Estado (UF)"
                    validateStatus={classInputs.estado}
                    help={classInputs.estado === 'error' ? 'Campo obrigatório' : ''}
                  >
                    <InputMask
                      mask="aa"
                      value={endereco.estado}
                      onChange={this.alterarForm.bind(this)}
                      disabled={isReadOnly}
                      className="ant-input ant-input-lg"
                      style={{ textTransform: 'uppercase' }}
                      name="estado"
                      placeholder="UF"
                    />
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </div>

          {!contrato.enderecoPreenchido && (
            <div style={{ marginTop: 24, textAlign: 'right' }}>
              <Button
                id="btnFinalizarEtapa"
                type="primary"
                danger
                size="large"
                icon={<SaveOutlined />}
                loading={this.state.botaoFinalizar}
                onClick={this.salvarInformacoesEntrega.bind(this)}
                style={{ minWidth: '200px', height: '50px', fontSize: '16px', borderRadius: '6px' }}
              >
                Finalizar Etapa
              </Button>
            </div>
          )}
        </Card>

        {/* Modal Sucesso */}
        <Modal
          visible={this.state.showModalNotificacao}
          onCancel={() => this.setState({ showModalNotificacao: false })}
          footer={null}
          centered
          width={600}
        >
          <Result
            status="success"
            title="Cadastro realizado com sucesso!"
            subTitle="As informações de faturamento e entrega foram salvas. A próxima etapa é o cadastro dos perfis do Instagram."
            extra={[
              <a key="instagram" href="./instagram">
                <Button type="primary" size="large" icon={<InstagramOutlined />}>
                  Ir para Perfis do Instagram
                </Button>
              </a>
            ]}
          />
        </Modal>

        <Joyride
          continuous={true}
          run={this.state.run}
          scrollToFirstStep={true}
          showProgress={true}
          showSkipButton={true}
          steps={this.state.steps}
          styles={{
            options: {
              zIndex: 10000,
              primaryColor: '#ff4d4f',
            },
          }}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    usuario: state.usuario.autenticado,
    contrato: state.contrato.especifico,
    formandos: state.formando.todos,
    itens: state.item.todos
  }
}
export default connect(mapStateToProps, { cadastrarAcao, salvarEndereco, editarContrato, obterContratoPeloUsuario })(InformacoesEntrega);